export default {
  mobile_app_average_order_value: {
    label: 'Ticket medio vía App',
  },
  mobile_app_gmv: {
    label: 'Ventas en App',
  },
  mobile_app_gmv_percentage: {
    label: '% de ingresos vía App',
  },
  mobile_app_downloads: {
    label: 'Descargas',
  },
  mobile_app_orders_count: {
    label: 'Pedidos en App',
  },
  name: {
    label: 'Restaurante',
  },
  mobile_app_released_at: {
    label: 'Fecha de lanzamiento',
  },
  title: 'Directorio de restaurantes',
};
